// Third party libraries
import * as $ from 'jquery';
const VueGallerySlideshow = () => import(/* webpackPrefetch: true, webpackChunkName: "vue-gallery-slideshow"*/ 'vue-gallery-slideshow');

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';

// Services
import SocialClubService from '@/app/services/main/social-club/social-club-service';
import PostService from '@/app/services/main/post/post-service';
import CommentService from '@/app/services/main/comments/comments-service';

// Constants
import { STATUS_CODES, CONTENT_TYPE, CONTENT_STATUS} from '@/app/constants/constants';

export default {
	name: 'ModalPreviewReportedContent',
	components: {
		VueGallerySlideshow
	},
	mixins: [
		dateMixins,
		toastMessageMixins
	],
	data() {
		return {
			index: null,
			isAPILoading: true,
			isReportAPILoading: false,
			reporterDetails: null,
			reportedName: '',
			reportedContent: '',
			createdAt: null,
			mediaFiles: []
		}
	},
	computed: {
		getMediaLinks() {
			return this.mediaFiles.map(({ location }) => location);
		}
	},
	beforeDestroy() {
		this.closeModal();
	},
	methods: {
		show(content, groupId) {
			this.reporterDetails = {
				...content,
				groupId
			};
			this.clearData();
			$(this.$refs.modalReportedContent).modal('show');
			this.loadData();
		},
		loadData() {
			const { contentId, contentType } = this.reporterDetails;
			const { POST, COMMENT } = CONTENT_TYPE;

			if (contentType === POST) {
				this.callPostService(contentId);
			} else if (contentType === COMMENT) {
				this.callCommentService(contentId);
			}
		},
		callPostService(contentId) {
			this.isAPILoading = true;

			PostService.getPostById(contentId)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const { content, firstName, lastName, mediaFiles, createdAt } = res.data;
						this.reportedName = `${firstName} ${lastName}`;
						this.reportedContent = content;
						this.mediaFiles = mediaFiles;
						this.createdAt = this.formatDate(createdAt, 'MMMM dd, yyyy p', true);
					} else {
						this.showCustomErrorToast(res.data.errors[0].message, null, true);
					}

					this.isAPILoading = false;
				});
		},
		callCommentService(contentId) {
			this.isAPILoading = true;
			CommentService.getCommentById(contentId)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const { content, firstName, lastName, mediaFile, createdAt } = res.data;
						this.reportedName = `${firstName} ${lastName}`;
						this.reportedContent = content;
						this.createdAt = this.formatDate(createdAt, 'MMMM dd, yyyy p', true);

						if (Object.keys(mediaFile).length > 0) {
							this.mediaFiles.push(mediaFile);
						}
					} else {
						this.showCustomErrorToast(res.data.errors[0].message, null, true);
					}

					this.isAPILoading = false;
				});
		},
		closeModal() {
			$(this.$refs.modalReportedContent).modal('hide');
		},
		async actionReportedContent(type) {
			const { value } = await this.$swal({
				imageHeight: '150px',
				imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
				imageAlt: 'Confirm Dog',
				titleText: `${type} Reported Content`,
				text: `Are you sure you want to ${type} this content?`,
				confirmButtonText: 'Confirm',
				cancelButtonText: 'Cancel',
				customClass: {
					header: 'header-social-club',
					title: 'title-social-club'
				},
				showCancelButton: true,
				reverseButtons: true,
				showCloseButton: true
			});

			if (value) {
				const {groupId, id} = this.reporterDetails;
				this.isReportAPILoading = true;
				const reqBody = {
					reportId: id,
					status : type === 'approve' ? CONTENT_STATUS.APPROVED : CONTENT_STATUS.DISAPPROVED
				};

				SocialClubService.putActionReportedContent(groupId, reqBody)
					.then(res => {
						const { SUCCESS_REPORT_CONTENT } = this.toastMessages.reportContent(type);

						if (res.status === STATUS_CODES.SUCCESS) {
							this.showCustomSuccessToast(null, SUCCESS_REPORT_CONTENT);
							this.$emit('refreshAdminTable');
							this.closeModal();
						} else {
							this.showCustomErrorToast(res.data.errors[0].message, null, true);
						}

						this.isReportAPILoading = false;
					})
					.catch(() => {
						this.showGenericErrorToast();
						this.isReportAPILoading = false;
					});
			}
		},
		clearData() {
			this.reportedName = '';
			this.reportedContent = '';
			this.mediaFiles = [];
			this.createdAt = null;
		}
	}
}